<template>
  <div
    class="bg-white rounded-3xl p-4"
    :class="{
      shimmerContainer:
        fees?.loadingFees ||
        $stores.services.state.transactionInitiation.convertingAmount
    }"
  >
    <!-- v-if="!$stores?.services?.state?.initiationError" -->
    <!-- Bonus Section -->
    <div class="rounded-2xl p-4 mb-4 bg-[#E8E7FF]" v-if="fees.bonus > 0">
      <div class="flex justify-between items-center">
        <span class="font-bold title-color shimmerTarget">Bonus offert</span>
        <span class="shimmerTarget text-xl font-bold title-color">
          {{ formatAmount(fees.bonus) }} CFA
        </span>
      </div>
    </div>

    <!-- Transaction Details -->
    <div class="space-y-3 mb-6">
      <div
        class="flex justify-between items-center py-2 border-b border-gray-100"
        v-if="transactionData.recipientAmount"
      >
        <span class="text-gray-600 shimmerTarget">Montant</span>
        <span
          class="shimmerTarget font-medium text-gray-900"
          v-if="operation.id == 'withdraw' || operation.id == 'sell'"
          >{{ formatAmount(transactionData.senderAmount) }} CFA</span
        >
        <span class="shimmerTarget font-medium text-gray-900" v-else
          >{{ formatAmount(transactionData.recipientAmount) }} CFA</span
        >
      </div>

      <div
        class="flex justify-between items-center py-2 border-b border-gray-100"
        v-if="fees.fee > 0"
      >
        <span class="text-gray-600 shimmerTarget">Frais</span>
        <span class="shimmerTarget font-medium text-gray-900"
          >{{ formatAmount(fees.fee) }} CFA</span
        >
      </div>

      <div
        class="flex justify-between items-center py-2 border-b border-gray-100"
        v-if="transactionData.phoneNumber"
      >
        <span class="text-gray-600 shimmerTarget">Téléphone</span>
        <span class="shimmerTarget font-medium text-gray-900">{{
          transactionData.phoneNumber
        }}</span>
      </div>

      <div
        class="flex justify-between items-center py-2 border-b border-gray-100"
        v-if="transactionData.email"
      >
        <span class="text-gray-600 shimmerTarget">Email</span>
        <span class="shimmerTarget font-medium text-gray-900">{{
          transactionData.email
        }}</span>
      </div>

      <div
        class="flex justify-between items-center py-2 border-b border-gray-100"
        v-if="transactionData.bookmakerIdToUse"
      >
        <span class="text-gray-600 shimmerTarget">ID bookmaker</span>
        <span class="shimmerTarget font-medium text-gray-900">
          <BookmakerAccountDetail
            :bookmaker="service.id"
            :bookmakerId="transactionData.bookmakerIdToUse"
          />
        </span>
      </div>
    </div>

    <!-- Total Amount -->
    <div class="rounded-2xl p-4 shimmerTarget bg-[#E8E7FF] title-color">
      <div
        class="flex justify-between items-center"
        v-if="operation.id == 'withdraw'"
      >
        <span class="font-bold">Total à recevoir</span>
        <span class="text-2xl font-bold">
          {{ formatAmount(transactionData.recipientAmount) }}
          CFA
        </span>
      </div>
      <div v-else-if="operation.id == 'buy'">
        <div class="flex justify-between items-center">
          <span class="font-bold">Total à payer</span>
          <span class="text-2xl font-bold">
            {{ formatAmount(transactionData.senderAmount) }}
            CFA
          </span>
        </div>
        <div class="py-2"></div>
        <div class="flex justify-between items-center">
          <span class="font-bold">Total à recevoir</span>
          <span class="text-2xl font-bold">
            {{ formatAmount(transactionData.recipientAmountOriginalCurrency) }}
            USDT
          </span>
        </div>
      </div>
      <div v-else-if="operation.id == 'sell'">
        <div class="flex justify-between items-center">
          <span class="font-bold">Total à recevoir</span>
          <span class="text-2xl font-bold">
            {{ formatAmount(transactionData.recipientAmount) }}
            CFA
          </span>
        </div>
        <div class="py-2"></div>
        <div class="flex justify-between items-center">
          <span class="font-bold">Total à envoyer</span>
          <span class="text-2xl font-bold">
            {{ formatAmount(transactionData.senderAmountOriginalCurrency) }}
            USDT
          </span>
        </div>
      </div>
      <div class="flex justify-between items-center" v-else>
        <span class="font-bold">Total à payer</span>
        <span class="text-2xl font-bold">
          {{ formatAmount(transactionData.senderAmount) }}
          CFA
        </span>
      </div>
    </div>
  </div>
  <!-- <div
    v-else-if="transactionData.senderAmount && transactionData.recipientAmount"
  >
    <div class="p-4 rounded-xl text-red-500 bg-primary font-bold">
      <span>
        <ColorImg
          class="inline-block bg-current w-5 h-5 -mb-1"
          src="/images/icons/close.svg"
          alt=""
        />
      </span>
      {{ $stores?.services?.state?.initiationError }}
    </div>
  </div> -->
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ServiceSummaryDialog',
  data() {
    return {};
  },
  computed: {
    service() {
      return this.$stores.services?.state?.transactionInitiation?.service;
    },
    operation() {
      return this.$stores.services?.state?.transactionInitiation?.operation;
    },
    fees() {
      return this.$stores.services?.state?.transactionInitiationFees || {};
    },
    transactionData() {
      return this.$stores.services?.state?.transactionInitiation || {};
    }
  },
  mounted() {},
  methods: {
    getServiceType() {
      if (
        this.service?.id === 'bookmaker' ||
        ['1xbet', 'betwinner', 'melbet', 'eightstarz', '1win'].includes(
          this.service?.id
        )
      ) {
        return 'bookmaker';
      } else if (this.service?.id === 'usdt') {
        return 'usdt';
      } else if (this.service?.id === 'giftCard') {
        return 'giftcard';
      } else if (this.service?.id === 'subscription') {
        return 'subscription';
      }
      return 'other';
    },

    getOperationType() {
      // Pour les cartes cadeaux, vérifier si c'est un achat ou une vente
      if (this.service?.id === 'giftCard') {
        return this.operation?.id === 'buy' ? 'Achat' : 'Vente';
      }

      // Pour l'USDT
      if (this.service?.id === 'usdt') {
        if (this.operation?.id === 'buy') return 'Achat';
        if (this.operation?.id === 'sell') return 'Vente';
      }

      // Pour les autres services
      if (this.operation?.id === 'fund' || this.operation?.id === 'buy')
        return 'Recharge';
      if (this.operation?.id === 'withdraw' || this.operation?.id === 'sell')
        return 'Retrait';
      if (this.service?.id === 'subscription') return 'Abonnement';
      return 'Transaction';
    },

    formatAmount(amount) {
      if (!amount) return '0';
      return new Intl.NumberFormat('fr-FR').format(amount);
    }
  }
});
</script>
